import Bulut from "../assets/images/storage.jpg";


const StorageSolutions = () => {
  return (
    <>
      <main className="container max-w-7xl mx-auto px-2 py-2 bg-white">
        <div className="text-center  py-2 mb-2 mt-2">
          {/* img and title */}
          <div className="flex justify-center items-center flex-col sm:flex-row">
            <div>
              <img src={Bulut} className="max-w-[460px]" />
            </div>
            <div className="text-center sm:text-left">
              <h2 className="text-teal-500 text-5xl sm:text-6xl font-bold font-sans opacity-[0.9]">
                STORAGE SOLUTIONS
              </h2>
              <p className="text-gray-500 text-5xl sm:text-6xl font-sans font-bold mt-4">
                Scale Securely
              </p>
            </div>
          </div>
          <hr className="border-teal-400 border-[1.5px] dark:border-gray-700 mt-4 "></hr>
        </div>
      </main>

      {/* <main className="container  max-w-7xl mx-auto px-2 py-2 bg-white">
        <div className="text-center inline-block  py-2  mb-2 mt-2">
          <div className="flex justify-center items-center">
            <div>
              <img src={Bulut} className="" />
            </div>
            <div>
              <h2 className=" text-teal-500 text-6xl font-bold font-sans">
                STORAGE SOLUTIONS
              </h2>
              <p className="  text-gray-500 text-6xl font-sans font-bold mt-4 ">
                Scale Securely
              </p>
            </div>
          </div>
          <hr className="border-teal-400 border-[1.5px] dark:border-gray-700 "></hr>
        </div>
      </main> */}
      {/* main2 */}
      <main className="bg-white">
        <main className="container max-w-7xl text-xl font-bold text-gray-700 mx-auto px-2 py-2 ">
          {/* section */}
          <section className="text-gray-600 bg-white grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 xl:grid-cols-3 gap-8 rounded-lg mt-2 mb-8 opacity-[0.9]">
            <div className="p-6 rounded-lg">
              <div className="flex justify-center items-center" />
              <h3 className="text-teal-500 text-2xl font-bold font-sans  mb-4">
                CLOUD STORAGE FOR EVERY BUSINESS
              </h3>
              <p>
                Flexibly secure and accessible, AWS S3 storage solutions cater
                to any stage of your cloud integration, ensuring reliable data
                backup for all operations.
              </p>
            </div>
            <div className="p-6 rounded-lg">
              <h3 className="text-teal-500 text-2xl font-bold  mb-4">
                DATA STORAGE STRATEGIZING
              </h3>
              <p>
                Strategically deploy AWS S3 for optimal data management and cost
                savings, enhancing efficiency across frequently accessed or
                archived data.
              </p>
            </div>
            <div className="p-6 rounded-lg">
              <h3 className="text-teal-500 text-2xl font-bold  mb-4">
                STORAGE COST ASSESSMENT
              </h3>
              <p>
                Control your storage budget with our cost assessment, optimizing
                your AWS S3 usage to align perfectly with your storage needs.
              </p>
            </div>
            <div className="p-6 rounded-lg">
              <h3 className="text-teal-500 text-2xl font-bold  mb-4">
                SCALABILITY WITHOUT COMPLEXITY
              </h3>
              <p>
                Experience seamless scalability with AWS storage solutions that
                adapt effortlessly to your business’s evolving demands, free of
                unnecessary costs.
              </p>
            </div>
            <div className="p-6 rounded-lg">
              <h3 className="text-teal-500 text-2xl font-bold  mb-4">
                OPTIMIZED DATA ACCESSIBILITY
              </h3>
              <p>
                Ensure swift and cost-effective data access with our AWS S3
                optimization, delivering the right balance of speed and
                availability.
              </p>
            </div>
            <div className="p-6 rounded-lg">
              <h3 className="text-teal-500 text-2xl font-bold  mb-4">
                UNMATCHED DATA PROTECTION
              </h3>
              <p>
                Rely on the most stringent AWS security measures we implement,
                for robust data protection that complies with regulations at
                every cloud journey stage.
              </p>
            </div>
          </section>
        </main>
      </main>
      {/* main3 */}
      <main className="bg-[#c1e7e2] rounded-xl container max-w-7xl text-lg text-zinc-600 font-bold mx-auto px-4 py-2 mb-8">
        <div className="text-center mb-8">
          <h2 className="text-4xl mb-4 mt-6">DISCOVER HOW WE CAN HELP YOU</h2>
          <p className="text-2xl ">
            Elevate Your Data Management with Specialized AWS Storage Services
          </p>
        </div>
        <section className="grid text-lg text-zinc-600 font-bold grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          <div className="p-6 rounded-lg">
            <div className="flex justify-center items-center" />
            <svg
              className="h-40 w-40  text-zinc-600"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M17 8h2a2 2 0 012 2v6a2 2 0 01-2 2h-2v4l-4-4H9a1.994 1.994 0 01-1.414-.586m0 0L11 14h4a2 2 0 002-2V6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2v4l.586-.586z"
              />
            </svg>
            <br />
            <h3 className="text-2xl mb-4">RELIABLE DATA STORAGE</h3>
            <p>
              Securely store your data across any environment with our AWS-based
              storage solutions, ensuring accessibility and protection at all
              times.
            </p>
            <a
              href="#"
              className="inline-block mt-20 bg-zinc-600 hover:bg-teal-500 text-white font-bold py-2 px-4 rounded"
            >
              Learn More
            </a>
          </div>
          <div className="p-6 rounded-lg">
            <svg
              className="h-40 w-40 text-zinc-600"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth={2}
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              {" "}
              <polygon points="12 2 2 7 12 12 22 7 12 2" />{" "}
              <polyline points="2 17 12 22 22 17" />{" "}
              <polyline points="2 12 12 17 22 12" />
            </svg>
            <br />
            <h3 className="text-2xl  mb-4">COST-EFFICIENT STORAGE PLANNING</h3>
            <p>
              Optimize your AWS storage spend with our tailored planning,
              ensuring you get the most cost-effective storage class for your
              needs.
            </p>
            <a
              href="#"
              className="inline-block mt-11  bg-zinc-600 hover:bg-teal-500 text-white font-bold py-2 px-4 rounded"
            >
              Learn More
            </a>
          </div>

          <div className="p-6 rounded-lg">
            <svg
              className="h-40 w-40 text-zinc-600"
              viewBox="0 0 24 24"
              strokeWidth={2}
              stroke="currentColor"
              fill="none"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              {" "}
              <path stroke="none" d="M0 0h24v24H0z" />{" "}
              <path d="M9 4h3l2 2h5a2 2 0 0 1 2 2v7a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-9a2 2 0 0 1 2 -2" />{" "}
              <path d="M17 17v2a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-9a2 2 0 0 1 2 -2h2" />
            </svg>
            <br />
            <h3 className="text-2xl  mb-4">SCALABLE STORAGE SOLUTIONS</h3>
            <p>
              Grow your storage seamlessly with our AWS solutions, providing
              flexibility for data surges and efficiency for lower demand
              periods.
            </p>
            <a
              href="#"
              className="inline-block mt-11 bg-zinc-600  hover:bg-teal-500 text-white font-bold py-2 px-4 rounded"
            >
              Learn More
            </a>
          </div>
        </section>
      </main>
    </>
  );
};

export default StorageSolutions;
